
import { Injectable } from '@angular/core';
import { DomainDetails } from '../app.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalVariablesService {

  constructor() {
  }

  public domainDetails: DomainDetails;

  public copyrightText: string;

  public avgChartColors = [
    '#663300',
    '#cc3300',
    '#ff0000',
    '#990033',
    '#990099',
    '#005266',
    '#bf40bf',
    '#996633',
    '#ffff00',
    '#ff6600',
    '#cc0066',
    '#99ff33',
    '#ff9999',
    '#00ffff',
    '#339966',
    '#669999',
    '#666699',
    '#bf80ff',
    '#b3c6ff',
    '#99ffdd',
    '#004d33'
  ];

  public FILTER_FORM_MAPPING = {
    reportTypes: [
      { label: 'Exceedance Report', key: 'exceedenceReport' },
      { label: 'Proactive Report', key: 'proactiveReport' },
      { label: 'Exceedance Count Report', key: 'exceedanceCount' },
      { label: 'Station Wise Report', key: 'stationWiseReport' },
      { label: 'Parameter Summary Report', key: 'parameterSummaryReport' },
      { label: 'Data Availability Report', key: 'dataAvailabilityReport' },
      { label: 'Data Availability Day Wise Report', key: 'dataAvailabilityDayWiseReport' },
      { label: 'Histogram Report', key: 'histogramReport' },
      { label: 'AQI Monthly Calender View', key: 'month' },
      { label: 'Percentile Report', key: 'percentileReport' },
      { label: 'Scatter Plot Report', key: 'scatterPlotReport' },
      { label: 'Uptime Report', key: 'upTimeReport' },
      { label: 'Windrose Polarised Report', key: 'polarReport' },
      { label: 'AQI Data Report', key: 'aqiDataReport' },
      { label: 'Windrose Report', key: 'windRoseReport' },
      { label: 'AQI Level Report', key: 'aqiLevelReport' },
      { label: 'Manage Complaints', key: 'manageComplaints' },
      { label: 'List Site Parameter', key: 'listSiteParameter' },
      { label: 'Meteorological Report', key: 'meteorologicalReport' },
      { label: 'Meteorological Report', key: 'metrologicalReport' },
      { label: 'Average Summary Report', key: 'averageSummaryReport' },
      { label: 'Averagy Report Loader', key: 'averageReportLoader' },
      { label: 'Shift Report', key: 'shiftReport' },
      { label: 'Alert Setup', key: 'alertSetup' },
      { label: 'Collector Setup', key: 'collectorSetup' },
      { label: 'Monitoring Station Setup', key: 'monitoringStationSetup' },
      { label: 'Parameter Setup', key: 'parameterSetup' },
      { label: 'Site Configuration', key: 'siteConfiguration' },
      { label: 'Exceedence Report', key: 'alarmReport' },
      { label: 'Complaints Inspection', key: 'complaintsInspection' },
      { label: 'Quality Control Charts', key: 'qualityControlCharts' },
      { label: 'Calibration Logs', key: 'calibrationLogs' },
      { label: 'Rain Report', key: 'rainReport' },
      { label: 'EPDA Custom Report', key: 'epdaCustomReportLoader' },
      { label: 'Diurnal Report Loader', key: 'diurnalReportLoader' },
    ],
    schduledReportTypes: [
      { label: 'Average Report', key: 'averageReportLoader' },
      // { label: 'Average Summary Report', key: 'averageSummaryReport' },
      { label: 'Exceedance Report', key: 'exceedenceReport' },
      // { label: 'Exceedance Count Report', key: 'exceedanceCount' },
      { label: 'Data Availability Report', key: 'dataAvailabilityReport' },
      // { label: 'Data Availability Day Wise Report', key: 'dataAvailabilityDayWiseReport' }
      { label: 'EPDA Custom Report', key: 'epdaCustomReportLoader' },
    ],
    // this filters can be override with featuresMapping.json filters
    staticFields: {
      epdaCustomReportLoader: [],
      month: ['time', 'station', 'standard'],
      proactiveReport: ['dateRange', 'station', 'parameter', 'standard'],
      histogramReport: ['dateRange', 'station', 'parameter', 'averageInterval'],
      percentileReport: ['dateRange', 'station', 'parameter'],
      scatterPlotReport: ['dateRange'],
      upTimeReport: ['dateRange', 'station'],
      polarReport: ['dateRange', 'station', 'parameters'],
      aqiDataReport: ['dateRange', 'stations', 'standard'],
      windRoseReport: ['dateRange'],
      aqiLevelReport: ['stations', 'dateRange', 'standard'],
      manageComplaints: ['calendarRange'],
      listSiteParameter: ['station', 'parameters', 'calendarRange'],
      meteorologicalReport: ['dateRange'],
      metrologicalReport: ['dateRange', 'station'],
      averageSummaryReport: ['dateRange'],
      dataAvailabilityDayWiseReport: ['calendarRange', 'station', 'parameters'],
      dataAvailabilityReport: ['dateRange'],
      complaintsInspection: ['dateRange'],
      exceedanceCount: ['dateRange', 'station', 'parameters'],
      exceedenceReport: ['dateRange', 'station', 'parameter', 'standard'],
      parameterSummaryReport: ['dateRange'],
      // averageReportLoader: ['dateRange', 'station', 'parameters', 'averageInterval'],
      averageReportLoader: ['dateRange', 'station', 'parameters'],
      diurnalReportLoader: ['dateRange', 'station', 'parameters'],
      shiftReport: ['dateRange', 'station', 'parameters'],
      stationWiseReport: ['dateRange', 'station'],
      realtimeDataReport: ['dateRange', 'station'],
      alertSetup: ['station'],
      collectorSetup: ['station'],
      monitoringStationSetup: ['station'],
      parameterSetup: ['station'],
      siteConfiguration: ['station'],
      alarmReport: ['dateRange', 'station', 'parameter'],
      maintenanceSetup: ['station'],
      systemStatusReport: ['station', 'parameter', 'dateRange'],
      operatingHours: ['station'],
      diagnosticParameter: ['station', 'parameter'],
      diagnostics: ['station', 'dateRange', 'parameter'],
      calibrationSetup: ['station'],
      calibrationLogs: ['dateRange'],
      qualityControlCharts: ['dateRange'],
      matrixReport: ['station', 'dateRange', 'parameter'],
      // totalizerReport: ['station', 'dateRange', 'parameters'],
      totalizerReport: ['dateRange'],
      aqiDataEntryList: ['dateRange'],
      // sharedSummaryReport: ['station', 'singleCalendar', 'parameters'],
      dailySummaryReport: ['station', 'singleCalendar', 'monitoringType'],
      monthlySummaryReport: ['station', 'monitoringType'],
      postDataValidation: ['station', 'dateRange', 'parameters'],
      dynamicLiveReport: ['station', 'parameter', 'dateRange'],
      monthlyReport: ['station', 'parameters'],
      notification: ['station', 'dateRange', 'parameter'],
      normalizationVerification: ['station', 'dateRange', 'parameter'],
      aqmsReport: ['dateRange'],
      epdaSummaryReport: ['stations'],
      playbackCamera: ['dateRange'],
      rainReport: ['dateRange']
    },
    formJsonExceptions: [
      'parameterSummaryReport',
      'dataAvailabilityReport',
      'aqiDataReport',
      'aqiLevelReport',
      'month',
      'manageComplaints',
      'siteConfiguration',
      'alertSetup',
      'aqmsReport'
    ],
    dateTimeFilters: ['dateRange', 'calendarRange', 'timeRange', 'singleDate', 'singleCalendar', 'singleTime']
  };
  public USER_ROUTE_ACCESS = [];
  public API_TO_JSON_MAP = {
    save_project_details: 'insert_building_component',
    update_building_component: 'insert_building_component',
    complaintAssignment: 'complaintManagementTabLoader',
    fetchAverageData: 'allMetReports',
    siteDashboardDetails: 'getStationInfo',
    fetchDashboardDataDM: 'requestRealTimeReport',
    searchUser: 'loadActiveSearchTable',
    displayLoad: 'displayBoardWindow',
    addadvancedparameter: 'advancedParameterReportLoader',
    deleteadvancedparameter: 'advancedParameterReportLoader',
    editadvancedparameter: 'advancedParameterReportLoader',
    CollectorFilter: 'loadAddCollector',
    deleteCollector: 'commonSuccessJson',
    siteConfUrl: 'deleteStation',
    iedassessmentupFetch: 'fetchiedaqra',
    iedAssessmentSetup: 'commonSuccessJson',
    iedSetupFetch: 'fetchiedpm1',
    iedsetup: 'commonSuccessJson',
    setupStationLoader: 'loadStationDetails',
    filterParameter: 'loadAddParameter',
    deleteParameter: 'commonSuccessJson',
    siteSetupLoader: 'loadSiteDetails',
    loadUserRole: 'loadFeatures',
    ExcelDump: 'excelDump',
    HTMLDump: 'excelDump',
    WordDump: 'excelDump',
    siteDashboardLoader: 'navHeader',
    editInspection: 'editInspectionDetails',
    fetchComplainList: 'complaintManagementTableLoader',
    fetchComplainStats: 'complaintManagementTableLoader'
  };
  public setUserRouteAccess(data) {
    const routes = [];
    try {
      data.forEach(menu => {
        routes.push(menu.route);
        if (menu.subMenus) {
          menu.subMenus.forEach(subMenu => {
            routes.push(subMenu.route);
          });
        }
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.USER_ROUTE_ACCESS = routes.filter(ele => ele !== '');
    }
  }
}
